import React from 'react';
import PropTypes from 'prop-types';
import { Components, Utils, translate } from 'versafleet-core';

class FilterPage extends React.Component {
  UNSAFE_componentWillMount() {
    this.setState({
      filter: structuredClone(this.props.filter),
    });
  }

  _onFilterChange = (fieldName, value) => {
    this.setState(prevState => ({
      filter: Utils.Helper.setFilter(prevState.filter, fieldName, value),
    }));
  }

  render() {
    const { strings } = this.props;

    return (
      <div className="vf-mobile-filter-page">
        <Components.Mobile.NavigationBar
          leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
          onLeftButtonClick={() => { this.props.onClose(); }}
          renderRightPanel={() => (
            <Components.Button
              iconClassName="versa-completed"
              id={`${this.props.id}__done-button`}
              onClick={() => this.props.onChange(this.state.filter)}
              showShadow={false}
            />
          )}
          title={this.props.title}
        />
        <Components.Layout>
          <Components.Layout.Subsection className="vf-mobile-filter-page__subsection">
            <Components.Layout.Subsection.Heading>
              {strings.tags}
            </Components.Layout.Subsection.Heading>
            <Components.Input.Tag
              onChange={value => this._onFilterChange('tags', value)}
              options={(this.props.tagList || []).map(tag => ({ value: tag, text: tag }))}
              value={this.state.filter.tags}
            />
          </Components.Layout.Subsection>
          <Components.Layout.Subsection className="vf-mobile-filter-page__subsection">
            <Components.Layout.Subsection.Heading>
              {strings.statuses}
            </Components.Layout.Subsection.Heading>
            <Components.Input.CheckboxGroup.WithArray
              columns={2}
              id={`${this.props.id}__state-checkbox`}
              onChange={value => this._onFilterChange('state', value)}
              options={this.props.statusOptions}
              value={this.state.filter.state}
            />
          </Components.Layout.Subsection>
          <Components.Sorter
            className="vf-mobile-filter-page__sorter"
            id={`${this.props.id}__sort`}
            isMobile
            name="filter-sort-options"
            onChange={value => this._onFilterChange(null, value)}
            options={this.props.sortOptions}
            orderValue={this.state.filter.order_by}
            value={this.state.filter.sort_by}
          />
        </Components.Layout>
      </div>
    );
  }
}

FilterPage.propTypes = {
  filter: PropTypes.shape(),
  id: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  sortOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.node]),
    text: PropTypes.string,
  })),
  statusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.node]),
    text: PropTypes.string,
  })),
  strings: PropTypes.shape({
    tags: PropTypes.string,
    statuses: PropTypes.string,
  }).isRequired,
  tagList: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  ),
  title: PropTypes.string,
};

FilterPage.defaultProps = {
  filter: {},
  id: 'vf-mobile-filter-page',
  onChange: () => {},
  onClose: () => {},
  sortOptions: [],
  statusOptions: [],
  tagList: [],
  title: 'Filter & Sort',
};

export default translate('MobileFilter')(FilterPage);
